import React from "react";
import CategoryText from "./category-text";
import StripButton from "./strip-button";

export default function PostFilterStrip({
  className,
  categories = [],
  current,
  onChange,
}) {
  const names = [...new Set(categories)].sort();
  return (
    <div className="flex flex-wrap border-gray-400 w-auto uppercase justify-center -space-x-px -space-y-px">
      <div />
      {names.map((displayName) => (
        <StripButton
          key={displayName}
          selected={current === displayName}
          onClick={() =>
            onChange(current === displayName ? undefined : displayName)
          }
        >
          <CategoryText>{displayName}</CategoryText>
        </StripButton>
      ))}
    </div>
  );
}
